<template>
    <DnPaginator
        class="base-paginator"
        :total-pages="totalPages"
        :current-page="currentPage"
        :query="false"
    >
        <template #gap>
            <div
                :key="`gap_${index}`"
                class="base-paginator__gap"
                aria-hidden
            />
        </template>

        <template #pageNumber="{ pageNumber }">
            <div
                v-if="pageNumber !== 1"
                class="base-paginator__separator"
            />

            <BaseButton
                :key="`pager_${pageNumber}`"
                class="base-button--round base-paginator__number"
                :data-active="currentPage === pageNumber"
                :element="NuxtLinkLocale"
                :to="pageNumber === 1 ? `${props.rootUrl}` : `${props.rootUrl}/page/${pageNumber}`"
            >
                {{ formatPageNumber(pageNumber) }}
            </BaseButton>
        </template>

        <template
            v-for="(_, slot) of $slots"
            v-slot:[slot]="scope"
        >
            <slot
                :name="slot"
                v-bind="scope"
            />
        </template>
    </DnPaginator>
</template>

<script setup>
import DnPaginator from '@digitalnatives/paginator';

const router = useRouter();
const route = useRoute();

defineEmits(['update:currentPage']);

const props = defineProps({
    rootUrl: {
        type: String,
        default: ''
    },
    totalPages: {
        type: Number,
        default: 0
    },
    currentPage: {
        type: Number,
        default: 0
    }
});

const NuxtLinkLocale = resolveComponent('NuxtLinkLocale');

function goToPage(pageNumber) {
    if (pageNumber < 1) {
        emit('update:currentPage', 1);
        router.push({
            path: `page/${1}`
        });

        return;
    }

    if (pageNumber > props.totalPages) {
        emit('update:currentPage', props.totalPages);

        return;
    }

    router.push({
        path: `${props.rootUrl}/page/${pageNumber}`,
        query: {
            ...route.query
        }
    });

    emit('update:currentPage', pageNumber);
}

const formatPageNumber = (pageNumber) => {
    if (pageNumber < 10) {
        return `0${pageNumber}`;
    }

    return pageNumber;
};
</script>

<style src="./BasePaginator.less" lang="less"></style>
